import Authenticated from "@/Layouts/Authenticated";
import { Link } from "@inertiajs/inertia-react";
import ReactDOM from "react-dom";
import { PlusSmIcon } from "@heroicons/react/solid";
import { useEffect, useState } from "react";

import DataTables from "datatables.net/js/jquery.dataTables.min";
import "datatables.net-responsive";
import PageHeading from "@/Components/PageHeading";

const Index = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Groups", route: null },
    ];

    const [datatable, setDatatable] = useState(null);

    useEffect(() => {
        setDatatable(
            new DataTables("#datatable", {
                processing: true,
                serverSide: true,
                retrieve: true,
                responsive: true,
                autoWidth: false,
                searchDelay: 1000,
                ajax: `${route("groups.datatable")}`,
                orderMulti: false,
                dom: "<'dt-header'lf>t<'dt-footer'ip>",
                language: {
                    lengthMenu: "Show Entries _MENU_",
                },
                columns: [
                    {
                        name: "id",
                        className: "dt-tr-first",
                        orderable: false,
                        searchable: false,
                        defaultContent: "",
                        render: function (data, type, row, meta) {
                            return meta.row + meta.settings._iDisplayStart + 1;
                        },
                    },
                    {
                        data: "name",
                        name: "name",
                        className: "dt-tr",
                    },
                    {
                        defaultContent: "-",
                        orderable: false,
                        searchable: false,
                        createdCell: function (
                            td,
                            cellData,
                            rowData,
                            rowIndex,
                            colIndex
                        ) {
                            return ReactDOM.render(
                                <Link
                                    href={route("groups.edit", rowData.id)}
                                    className="text-indigo-600 hover:text-indigo-900"
                                >
                                    Edit
                                </Link>,
                                td
                            );
                        },
                    },
                ],
            })
        );
    }, []);

    return (
        <div className="py-6">
            <PageHeading heading={"Groups"} breadcrumb={breadcrumb}>
                <span>
                    <Link
                        href={route("groups.create")}
                        className={"btn-base btn-light"}
                    >
                        <PlusSmIcon
                            className={"-ml-1 mr-2 h-5 w-5 text-gray-500"}
                            aria-hidden={true}
                        />
                        Add Group
                    </Link>
                </span>
            </PageHeading>
            <div className="mt-8">
                <div className="flex flex-col">
                    <div className="min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="min-w-full bg-white p-2 shadow sm:rounded-md">
                            <table
                                id="datatable"
                                className="mt-2 min-w-full divide-y divide-gray-200"
                            >
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th scope="col" className="dt-th">
                                            #SN
                                        </th>
                                        <th scope="col" className="dt-th">
                                            Group Name
                                        </th>
                                        <th
                                            scope="col"
                                            className="relative px-6 py-3"
                                        >
                                            <span className="sr-only">
                                                Actions
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Index.layout = (page) => <Authenticated title={"Groups"}>{page}</Authenticated>;

export default Index;
